import React from "react";

// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { red } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from '@mui/material/FormHelperText';

//API
import { fni18n } from "../../services/commonService";

import { theme } from '../../assets/themes';


const ROLE_TYPE = [
    { cd:'1', name:'ADMIN' },
    { cd:'2', name:'BRANCH' }, 
    { cd:'3', name:'STORE' }, 
    // {cd:'4', name:'ONLY_ME'}, //사용안함
];

const GroupDetailPage = (props) => {
    return (
    <div className="pop-container">
        {/* 상단메뉴명 */}
        <div className="header">
            {fni18n('그룹 설정')}
        </div>
        <div className="contents">
        <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
                <TableBody>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('그룹번호')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            placeholder="new"
                            name="grpCd"
                            value={props.data.grpCd || ""}
                            disabled
                            onChange={e => props.onChange(e)}
                            InputProps={{
                            readOnly: true,
                            }}
                            />
                        </FormControl> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('그룹명')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                                type="text"
                                size="small"
                                name="grpNm"
                                value={props.data.grpNm || ""}
                                onChange={e => props.onChange(e)}
                                error={props.showError && props.errors.grpNm}
                                helperText={props.errors.grpNm || ""}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('그룹유형')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl size="small" fullWidth={true}>
                        <Select
                            sx={{ minWidth: 100 }}
                            name="grpLevel"
                            value={props.data.grpLevel || ""}
                            onChange={e => props.onChange(e)}
                            >
                                {ROLE_TYPE.map((role) => (
                                <MenuItem key={role.cd} value={role.cd}>
                                    {role.name}
                                </MenuItem>
                                ))}
                        </Select>
                        <FormHelperText error={props.showError && props.errors.grpLevel}>{props.errors.grpLevel || ""}</FormHelperText>
                        </FormControl>
                    </TableCell>
                </TableRow>
                <TableRow>
                <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControlLabel
                            control={
                                <Checkbox
                                name="useYn"
                                checked={props.data.useYn === "Y" ? true : false}
                                onChange={e => props.onSwitchChange(e)}
                                />
                            }
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('입금가능')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControlLabel
                            control={
                                <Checkbox
                                name="inAvailYn"
                                checked={props.data.inAvailYn === "Y" ? true : false}
                                onChange={e => props.onSwitchChange(e)}
                                />
                            }
                        />
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('출금가능')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControlLabel
                            control={
                                <Checkbox
                                name="outAvailYn"
                                checked={props.data.outAvailYn === "Y" ? true : false}
                                onChange={e => props.onSwitchChange(e)}
                                />
                            }
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                    <TableCell className="table-cell" colSpan={5}>
                        <FormControl fullWidth>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            name="grpDesc"
                            value={props.data.grpDesc || ""}
                            onChange={e => props.onChange(e)}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
                </TableBody>            
            </Table>
        </TableContainer>
        </div>
    </div>
    )
}

export default GroupDetailPage;